import React, { useContext, useEffect } from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import { Loader } from '@alumni-ventures-group/react-shared/lib/components';
import PropTypes from 'prop-types';
import getCalendlyLink from '../../../../../shared/helpers/getCalendlyLink';
import { PlanContext } from '../../context/PlanContext';

import useStyles from '../styles';
import CalendlyInline from '../../../../../shared/components/CalendlyInline';
import hasCompletedInvestment from '../../helpers/hasCompletedInvestment';
import { TierType } from '../../constants';

function BookCall({ setNextDisabled }) {
  const classes = useStyles();
  const { userPortfolio, planningConfig } = useContext(PlanContext);
  const bookCallConfig = planningConfig?.bookCall;

  const calendlyLink = getCalendlyLink({
    isExistingInvestor: hasCompletedInvestment(userPortfolio),
    isDiamondOrGoldClub: [TierType.DIAMOND, TierType.GOLD].includes(
      userPortfolio?.tier,
    ),
  });

  useEffect(() => {
    setNextDisabled(!bookCallConfig);
  }, [bookCallConfig, setNextDisabled]);

  if (!bookCallConfig) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Loader />
      </Box>
    );
  }

  const { title, subtitle } = bookCallConfig;

  return (
    <Box className={classes.content}>
      <Typography
        variant="h1ExtraLarge"
        component="h1"
        style={{ color: '#191919' }}
      >
        {title}
      </Typography>

      { subtitle?.richtext && (
      <Typography
        variant="body2Inter"
        component="div"
        style={{ color: '#797979', padding: 15 }}
        dangerouslySetInnerHTML={{
          __html: subtitle.richtext,
        }}
      />
      )}
      <CalendlyInline link={calendlyLink} />
    </Box>
  );
}

BookCall.propTypes = {
  setNextDisabled: PropTypes.func.isRequired,
};

export default BookCall;
